var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin_8950282 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.9957 75.293L52.3434 98.8281C51.7906 99.5664 50.9215 100 49.9996 100L44.8564 72.5465L49.9996 47.0703H59.8141C61.4312 47.0703 62.7437 48.3828 62.7437 50V70.6055H67.652C68.7613 70.6055 69.775 71.2324 70.2711 72.2246C70.7672 73.2168 70.6598 74.4043 69.9957 75.293Z",
    fill: "#DE0062"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.1852 47.0703C38.568 47.0703 37.2555 48.3828 37.2555 50V70.6055H32.3473C31.2379 70.6055 30.2242 71.2324 29.7281 72.2246C29.232 73.2168 29.3395 74.4043 30.0035 75.293L47.6559 98.8281C48.2086 99.5664 49.0777 100 49.9996 100V47.0703H40.1852Z",
    fill: "#FF3344"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.4176 32.3496C79.4176 48.5957 66.2477 61.7676 49.9996 61.7676L37.8252 32.3486L49.9996 2.92969C66.2477 2.92969 79.4176 16.1016 79.4176 32.3496Z",
    fill: "#FCC100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50 2.92969V61.7676C33.752 61.7676 20.582 48.5957 20.582 32.3496C20.582 16.1016 33.752 2.92969 50 2.92969Z",
    fill: "#FFDB6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.8121 20.582C58.8121 22.1992 57.5016 23.5117 55.8824 23.5117H49.9996L48.1768 19.3359L49.9996 11.7676C51.6168 11.7676 52.9293 13.0801 52.9293 14.6973V17.6523H55.8824C57.5016 17.6523 58.8121 18.9629 58.8121 20.582Z",
    fill: "#FF9E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.8129 38.3594C58.8129 42.168 56.348 45.4102 52.9301 46.5801V50C52.9301 51.6172 51.6176 52.9297 50.0004 52.9297L46.9404 44.4662L50.0004 41.1875H50.1273C51.6859 41.1875 52.9535 39.918 52.9535 38.3594C52.9535 36.8008 51.6859 35.5312 50.1273 35.5312H50.0004L48.7635 32.3486L50.0004 29.6719H50.1273C54.9164 29.6719 58.8129 33.5703 58.8129 38.3594Z",
    fill: "#FF9E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M82.3473 32.3477C82.3473 50.1855 67.8375 64.6973 49.9996 64.6973L48.7627 61.7676L49.9996 58.8379C64.6051 58.8379 76.4879 46.9551 76.4879 32.3477C76.4879 17.7422 64.6051 5.85938 49.9996 5.85938L47.2002 2.92969L49.9996 0C67.8375 0 82.3473 14.5117 82.3473 32.3477Z",
    fill: "#FF9E36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M50 5.85938V0C32.1621 0 17.6523 14.5117 17.6523 32.3477C17.6523 50.1855 32.1621 64.6973 50 64.6973V58.8379C35.3945 58.8379 23.5117 46.9551 23.5117 32.3477C23.5117 17.7422 35.3945 5.85938 50 5.85938Z",
    fill: "#FCC100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.0469 26.3379V26.8457C47.0469 28.4043 48.3145 29.6719 49.873 29.6719H50V35.5312H49.873C45.084 35.5312 41.1875 31.6348 41.1875 26.8457V26.3379C41.1875 22.5293 43.6523 19.2871 47.0703 18.1172V14.6973C47.0703 13.0801 48.3828 11.7676 50 11.7676V23.5117H49.873C48.3145 23.5117 47.0469 24.7793 47.0469 26.3379Z",
    fill: "#FCC100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M44.1172 41.1875H50V52.9297C48.3828 52.9297 47.0703 51.6172 47.0703 50V47.0469H44.1172C42.498 47.0469 41.1875 45.7344 41.1875 44.1172C41.1875 42.498 42.498 41.1875 44.1172 41.1875Z",
    fill: "#FCC100"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/fee.88fcab64047f524255e128eeed1ae35b.svg";
export { ForwardRef as ReactComponent };